import Vue from 'vue'

import uiTextarea from './src/ui-textarea.vue';

Vue.component('ui-textarea', uiTextarea);

export default uiTextarea;



//////////////////
// WEBPACK FOOTER
// ./~/ui-textarea/index.js
// module id = 563
// module chunks = 0